var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkEarned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12968_42728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.658 120.124V120.624H133.158H159.282L152.193 139.829L152.129 140.002L152.193 140.175L159.282 159.38H124.244V145.347V144.847H123.744H36.2559H35.7559V145.347V159.38H0.717545L7.80688 140.175L7.87079 140.002L7.80687 139.829L0.717548 120.624H26.8416H27.3416V120.124V101.751H132.658V120.124ZM26.8416 150.966H27.3416V150.466V129.538V129.038H26.8416H13.5103H12.7928L13.0412 129.712L16.8398 140.002L13.0412 150.293L12.7928 150.966H13.5103H26.8416ZM35.7559 135.932V136.432H36.2559H123.744H124.244V135.932V110.665V110.165H123.744H36.2559H35.7559V110.665V135.932ZM146.49 150.966H147.207L146.959 150.293L143.16 140.002L146.959 129.712L147.207 129.038H146.49H133.158H132.658V129.538V150.466V150.966H133.158H146.49Z",
    fill: "#264073",
    stroke: "url(#paint0_linear_12968_42728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.688 70.7801L52.4998 70.9636L52.5442 71.2227L56.2514 92.8367L36.8407 82.6319L36.608 82.5096L36.3753 82.6319L16.9649 92.8369L20.6718 71.2229L20.7162 70.9638L20.528 70.7804L4.82448 55.4733L26.5262 52.3197L26.7863 52.2819L26.9027 52.0461L36.608 32.3808L46.3131 52.0459L46.4294 52.2816L46.6896 52.3194L68.3915 55.473L52.688 70.7801ZM45.8391 79.2684L46.7359 79.7399L46.5646 78.7414L44.8017 68.4622L52.2699 61.1827L52.9954 60.4756L51.9928 60.3299L41.6719 58.83L37.0564 49.4781L36.608 48.5696L36.1596 49.4781L31.5438 58.8303L21.2232 60.3301L20.2206 60.4758L20.9461 61.183L28.4143 68.4624L26.6514 78.7414L26.4801 79.7399L27.3769 79.2684L36.608 74.4153L45.8391 79.2684Z",
    fill: "#264073",
    stroke: "url(#paint1_linear_12968_42728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.938 70.7801L138.75 70.9636L138.794 71.2227L142.501 92.8367L123.091 82.6319L122.858 82.5096L122.625 82.6319L103.215 92.8369L106.922 71.2229L106.966 70.9638L106.778 70.7804L91.0745 55.4733L112.776 52.3197L113.036 52.2819L113.153 52.0461L122.858 32.3808L132.563 52.0459L132.679 52.2816L132.94 52.3194L154.642 55.473L138.938 70.7801ZM132.089 79.2684L132.986 79.7399L132.815 78.7414L131.052 68.4622L138.52 61.1827L139.245 60.4756L138.243 60.3299L127.922 58.83L123.306 49.4781L122.858 48.5696L122.41 49.4781L117.794 58.8303L107.473 60.3301L106.471 60.4758L107.196 61.183L114.664 68.4624L112.901 78.7414L112.73 79.7399L113.627 79.2684L122.858 74.4153L132.089 79.2684Z",
    fill: "#264073",
    stroke: "url(#paint2_linear_12968_42728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.438 40.7801L96.2498 40.9636L96.2942 41.2227L100.001 62.8367L80.5907 52.6319L80.358 52.5096L80.1253 52.6319L60.7149 62.8369L64.4218 41.2229L64.4662 40.9638L64.278 40.7804L48.5745 25.4733L70.2762 22.3197L70.5363 22.2819L70.6527 22.0461L80.358 2.38077L90.0631 22.0459L90.1794 22.2816L90.4396 22.3194L112.142 25.473L96.438 40.7801ZM89.5891 49.2684L90.4859 49.7399L90.3146 48.7414L88.5517 38.4622L96.0199 31.1827L96.7454 30.4756L95.7428 30.3299L85.4219 28.83L80.8064 19.4781L80.358 18.5696L79.9096 19.4781L75.2938 28.8303L64.9732 30.3301L63.9706 30.4758L64.6961 31.183L72.1643 38.4624L70.4014 48.7414L70.2301 49.7399L71.1269 49.2684L80.358 44.4153L89.5891 49.2684Z",
    fill: "#264073",
    stroke: "url(#paint3_linear_12968_42728)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12968_42728",
    x1: 21.3333,
    y1: 111.511,
    x2: 47.7706,
    y2: 184.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12968_42728",
    x1: 12.5121,
    y1: 42.1885,
    x2: 56.4413,
    y2: 88.9247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12968_42728",
    x1: 98.7621,
    y1: 42.1885,
    x2: 142.691,
    y2: 88.9247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12968_42728",
    x1: 56.2621,
    y1: 12.1885,
    x2: 100.191,
    y2: 58.9247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12968_42728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkEarned);
export default __webpack_public_path__ + "static/media/bookmark-earned.5564450f38b906f8ea45f8cde6cc106a.svg";
export { ForwardRef as ReactComponent };